module.exports = __webpack_public_path__ + "img/logo.fb20876c.svg";